import { render, staticRenderFns } from "./ThemeMainSettings.vue?vue&type=template&id=598a8383"
import script from "./ThemeMainSettings.vue?vue&type=script&lang=js"
export * from "./ThemeMainSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports